import { tyreSizeListQuerySchema } from '@chukua/common';
import { createTyreSize, listTyreSizes } from '../tyres.api';
import { TyreCatalogueSelect } from './TyreCatalogueSelect';

const PAGE_SIZE = 20;

interface TyreSizeSelectProps {
  id?: string;
  value?: string;
  onChange?: (value: string | undefined) => void;
  savedName?: string | null;
  canAdd: boolean;
}

const fetchSizes = (q: string | undefined) =>
  listTyreSizes(tyreSizeListQuerySchema.parse({ q, isActive: 'true', pageSize: PAGE_SIZE })).then((page) => page.items);
const addSize = (name: string) => createTyreSize({ name });

export function TyreSizeSelect(props: TyreSizeSelectProps) {
  return <TyreCatalogueSelect {...props} fetch={fetchSizes} add={addSize} noun="size" />;
}
